export const previewModePlaceholder = '%PREVIEW_MODE%'
export const funnelStepIdPlaceholder = '%FUNNEL_STEP_ID%'
export const urlPlaceholder = '%URL%'
export const affiliateIdPlaceholder = '%CONTACT_AFFILIATE_ID%'
export const isMobilePlaceholder = '%IS_MOBILE%'
export const affiliateLinkPlaceholder = '%AFFILIATE_LINK%'
export const agreementPlaceholder = '%AGREEMENT%'
export const isFreemiumUserPlaceholder = '%FREEMIUM_USER%'
export const captchaPlaceholder = '%CAPTCHA_OPEN_KEY%'
